import { createApiClient } from "../apiClientFactory";

export type UserBehaviorEventType =
  | "PageView"
  | "PurchaseCompleted"
  | "ModuleCompleted"
  | "ExerciseAnswered";

const apiClient = createApiClient("user-behavior-events");

/**
 * Fire-and-forget: records a user-behavior event to VictoriaMetrics (via the backend) for Grafana
 * dashboards. Never throws and never blocks the caller - a network failure or an expired/missing
 * token must not affect the feature the user is actually using. Independent of Application Insights
 * (src/telemetry/appInsights.ts) so events still flow even when App Insights is disabled.
 *
 * Skips the request entirely when there's no auth token, since the backend endpoint requires one.
 *
 * The endpoint path ("interactions", not "analytics"/"events"/"track") is deliberate: those words
 * are blocked client-side by default ad-blocker filter lists (e.g. EasyPrivacy in uBlock Origin),
 * which silently drops the request before it ever reaches the network.
 */
export function recordUserBehaviorEvent(
  eventType: UserBehaviorEventType,
  properties: Record<string, string> = {}
): void {
  if (!localStorage.getItem("token")) return;

  void apiClient
    .post("/interactions", { eventType, properties })
    .catch(() => {
      // Swallow errors: analytics must never surface to the user or break the calling flow.
    });
}
